/* eslint-disable no-param-reassign */
import moment from 'moment';
import { cpfMask } from '~/utils/masks';
import { IListColumn } from '~/models/listCol';

export const HeaderReportCancelSafe = [
  {
    id: 1,
    value: 'Nome titular',
    maxChar: 15,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 13,
  },
  {
    id: 3,
    value: 'Data Venda',
    maxChar: 16,
  },
  {
    id: 4,
    value: 'Data Cancelamento',
    maxChar: 16,
  },
  {
    id: 5,
    value: 'Status cartão',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 6,
    value: 'Tipo de Seguro',
    maxChar: 15,
  },
  {
    id: 7,
    value: 'UF',
    maxChar: 6,
    textAlign: 'center',
  },
];

export const BodyReportCancelSafe = (data: any) => {
  // let x = 0;

  const items = [];

  data?.forEach((i) => {
    if (i.dataCancelamento !== undefined) {
      const item: IListColumn[] = [
        // {
        //   type: 'id',
        //   value: x++,
        //   maxChar: 5,
        // },
        {
          value: i.nomeCliente ? i.nomeCliente : '-',
          maxChar: 15,
        },
        {
          value: i.cpf ? cpfMask(i.cpf).masked : '-',
          maxChar: 13,
        },
        {
          value: i.dataVenda ? moment(i.dataVenda).format('DD/MM/YYYY') : '-',
          maxChar: 16,
        },
        {
          value: i.dataCancelamento
            ? moment(i.dataCancelamento).format('DD/MM/YYYY')
            : '-',
          maxChar: 16,
        },
        {
          value: i.statusCartao ? i.statusCartao : '-',
          maxChar: 7,
        },
        {
          value: i.tipoBeneficio ? i.tipoBeneficio : '-',
          maxChar: 15,
        },
        {
          value: i.uf ? i.uf : '-',
          maxChar: 6,
          textAlign: 'center',
        },
      ];

      items.push(item);
    }
  });
  return items;
};

export const BodyReportCancelSafeCSV = (data: any) => {
  const dataCSV = [];

  data.forEach((csv) => {
    dataCSV.push({
      nomeCliente: csv.nomeCliente,
      cpf: csv.cpf,
      dataVenda: csv.dataVenda,
      loja: csv.loja,
      nomeOperador: csv.operador,
      dataCancelamento: csv.dataCancelamento,
      tipoBeneficio: csv.tipoBeneficio,
      statusCartao: csv.statusCartao,
      uf: csv.uf,
      motivoCancelamento: csv.motivoCancelamento,
      numeroBilhete: csv.numeroBilhete,
      numeroSorte: csv.numeroSorte,
      idSegurado: csv.idSegurado,
      idSolicitacao: csv.idSolicitacao,
    });
  });

  return dataCSV;
};

export const BodyTotalCancelSafe = (data: any) => {
  const totalTitular = data.reduce((acc, cur) => {
    return acc + 1;
  }, 0);
  return totalTitular;
};
